import * as React from 'react'

export class ComponentDidMount extends React.Component<{
  onMount: () => void
  children?: React.ReactNode
}> {
  componentDidMount() {
    this.props.onMount()
  }

  render() {
    return this.props.children || <> </>
  }
}

export class ComponentWillUnmount extends React.Component<{
  onUnmount: () => void
  children?: React.ReactNode
}> {
  componentWillUnmount() {
    this.props.onUnmount()
  }

  render() {
    return this.props.children || <> </>
  }
}

export class ComponentDidUpdate<A> extends React.Component<{
  value: A
  isTrue: (oldValue: A, newValue: A) => boolean
  onTrue: () => void
  onMountAsWell?: boolean
  children?: React.ReactNode
}> {
  componentDidMount() {
    this.props.onTrue()
  }

  componentDidUpdate(prevProps: { value: A }) {
    if (this.props.isTrue(prevProps.value, this.props.value))
      this.props.onTrue()
  }

  render() {
    return this.props.children || <> </>
  }
}
